import HttpService from '@/services/http/http.service';
import { DonationPriceViewModel, PayPalDonateViewModel, PayPalLogViewModel } from '@/types/apiServerContract';

const API_PATH = 'paypal/';

export class PayPalApi {
    public static async GetDonationSettings(): Promise<DonationPriceViewModel> {
        return HttpService.Get<DonationPriceViewModel>(API_PATH + 'GetDonationPrices');
    }

    public static async CreatePayment(donationId: number): Promise<PayPalDonateViewModel> {
        return HttpService.Get<PayPalDonateViewModel>(API_PATH + 'CreatePayment', {
            donationId: donationId
        });
    }

    public static async ExecutePayment(paymentId: string, payerId: string, token: string): Promise<PayPalLogViewModel> {
        return HttpService.Get<PayPalLogViewModel>(API_PATH + 'ExecutePayment', {
            paymentId,
            payerId,
            token
        });
    }
}
